var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpulseLoading5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_973_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 0H1.83333C0.822667 0 0 0.822333 0 1.83333V10.1667C0 11.1777 0.822667 12 1.83333 12H10.1667C11.1773 12 12 11.1777 12 10.1667V1.83333C12 0.822333 11.1773 0 10.1667 0ZM2.83333 2.66667H7.16667C7.44267 2.66667 7.66667 2.89033 7.66667 3.16667C7.66667 3.443 7.44267 3.66667 7.16667 3.66667H2.83333C2.55733 3.66667 2.33333 3.443 2.33333 3.16667C2.33333 2.89033 2.55733 2.66667 2.83333 2.66667ZM5.16667 9.33333H2.83333C2.55733 9.33333 2.33333 9.10967 2.33333 8.83333C2.33333 8.557 2.55733 8.33333 2.83333 8.33333H5.16667C5.44267 8.33333 5.66667 8.557 5.66667 8.83333C5.66667 9.10967 5.44267 9.33333 5.16667 9.33333ZM9.16667 6.5H2.83333C2.55733 6.5 2.33333 6.27633 2.33333 6C2.33333 5.72367 2.55733 5.5 2.83333 5.5H9.16667C9.44267 5.5 9.66667 5.72367 9.66667 6C9.66667 6.27633 9.44267 6.5 9.16667 6.5Z",
    fill: "#86D9FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_973_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpulseLoading5);
export default __webpack_public_path__ + "static/media/epulse-loading5.c05f047cf2e88a51d32c242bfd20b1b326f9d3735819eae3eae6fc0019810bab.svg";
export { ForwardRef as ReactComponent };